module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("Writing this book was a labor of love, one I couldn’t have achieved without the help of many people. I’d like to acknowledge some of you now. For those I’ve forgotten, please forgive me!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("First, Alisa Kwitney—not only are you a talented author, you are a seventies god! How you have all that great seventies info stored in your brain that you can recite at the drop of a hat, I don’t know, and I don’t care. The info you gave me helped me color this story, and I thank you for that. Also, thank you for steering me in the right direction regarding voodoo. Any mistakes in this work are my own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Melinda Jones-McGowan, my dear, dear friend—have I thanked you for falling for a guy in New Orleans? Now that you live there, it came in handy not only to pick your brain regarding the city, but to enlist you to give me a personal tour. Thanks so much! And thanks also for those delicious daiquiris.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thanks also to Escalante Lundy, a native of New Orleans, for information on the history of the city and its neighborhoods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wish to also thank another talented author friend, Deborah (a.k.a. Sabrina Jeffries). I appreciate your patience for all my New Orleans questions! Thanks for steering me onto Marie Goodwin, New Orleans historian and author. Marie, your help regarding the Creole heritage was limitless and extremely helpful to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Again, if I’ve forgotten anyone, forgive me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcc4654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 72
// module chunks = 0